import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import classNames from 'classnames';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './ResetBtn.module.scss';
import { DevicesContext, IDevicesContext } from 'modules/Devices/Devices/devicesState/devicesContext';

const ResetBtn: React.FC = () => {
	const { resetSelectedControls, searchString, IDSelectedCustomer, IDSelectedRestaurant } =
		useContext<IDevicesContext>(DevicesContext);

	const resetBtnClasses = classNames(style.resetBtn, {
		[style.active]: searchString || IDSelectedCustomer || IDSelectedRestaurant,
	});

	return (
		<Button
			className={resetBtnClasses}
			theme="secondary"
			onClick={resetSelectedControls}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};

export default ResetBtn;
